import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "28",
  height: "28",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#F0F0F0",
      d: "M13.999 25.666c6.443 0 11.666-5.223 11.666-11.666S20.442 2.333 14 2.333 2.332 7.556 2.332 14c0 6.443 5.223 11.666 11.667 11.666"
    }, null, -1),
    _createElementVNode("path", {
      fill: "#D80027",
      d: "M18.057 14c0 1.014-1.816 3.55-4.058 3.55-2.24 0-4.058-2.536-4.058-3.55a4.058 4.058 0 1 1 8.116 0"
    }, null, -1),
    _createElementVNode("path", {
      fill: "#0052B4",
      d: "M18.057 14a4.058 4.058 0 1 1-8.116 0"
    }, null, -1),
    _createElementVNode("path", {
      fill: "#000",
      d: "m18.3 17.587 1.077-1.076.717.717-1.076 1.076zM16.508 19.38l1.076-1.076.717.717-1.076 1.076zM20.453 19.738l1.076-1.076.717.718-1.076 1.076zM18.656 21.531l1.076-1.076.717.718-1.076 1.076zM19.375 18.662l1.076-1.076.717.718-1.076 1.075zM17.582 20.456l1.076-1.076.717.717-1.076 1.076zM20.457 10.415l-2.869-2.869.717-.717 2.87 2.869zM17.586 9.697 16.51 8.621l.717-.717 1.076 1.076zM19.379 11.491l-1.076-1.076.717-.717 1.076 1.076zM19.738 7.546 18.662 6.47l.718-.717 1.076 1.076zM21.531 9.34l-1.076-1.076.718-.717 1.076 1.076zM6.469 18.66l2.869 2.87-.718.716-2.868-2.869zM9.336 19.377l1.076 1.076-.717.717-1.076-1.076zM7.543 17.584l1.076 1.076-.717.717-1.076-1.076zM8.621 16.509l2.87 2.869-.718.717-2.87-2.869zM9.336 6.468 6.467 9.337l-.717-.718 2.869-2.868zM10.414 7.543l-2.869 2.869-.717-.717 2.869-2.87zM11.488 8.62 8.62 11.49l-.717-.718 2.87-2.87z"
    }, null, -1)
  ])))
}
export default { render: render }